import type { AuthError } from '@supabase/supabase-js';
import { getAuthErrorCode } from '@ubus/shared';
import type { TFunction } from 'i18next';

export function translateAuthError(
  error: AuthError | Error,
  t: TFunction,
  mode: 'email' | 'phone' = 'phone'
): string {
  const code = getAuthErrorCode(error, mode);
  if (code === 'raw') {
    return error.message?.trim() || t('errors.auth.raw');
  }
  return t(`errors.auth.${code}`, { context: mode });
}
